module.exports = function() {
  return new Worker(__webpack_public_path__ + "363298686cc823963612.worker.js");
};